import { CommandExecutor } from "../engine/commands/CommandExecutor.js";
import { CommandParser } from "../engine/commands/CommandParser.js";
import type { MountainCommand } from "../engine/commands/MountainCommand.js";
import type { AssistantResponse } from "../engine/types/AssistantResponse.js";
import type { MountainContext } from "../engine/types/MountainContext.js";
import { MountainAIAdapter } from "./MountainAIAdapter.js";
import type { TheraRuntimeSnapshot } from "./TheraIntegrationInput.js";

export interface MountainAIIntegrationResult {
  readonly recognized: boolean;
  readonly command: MountainCommand | null;
  readonly context: MountainContext;
  readonly response: AssistantResponse | null;
}

export class MountainAIIntegrationService {
  constructor(
    private readonly adapter: MountainAIAdapter = new MountainAIAdapter(),
    private readonly parser: CommandParser = new CommandParser(),
    private readonly executor: CommandExecutor = new CommandExecutor(),
  ) {}

  async ask(input: string, snapshot: TheraRuntimeSnapshot): Promise<MountainAIIntegrationResult> {
    const context = this.adapter.toMountainContext(snapshot);
    const parsed = this.parser.parse(input);
    if (!parsed) return { recognized: false, command: null, context, response: null };
    const response = await this.executor.execute(parsed.command, context);
    return { recognized: true, command: parsed.command, context, response };
  }
}
